export default __webpack_public_path__ + "static/media/ordinationIcon.c3d157a8.svg";